(function () {
    'use strict';

    angular
        .module('elogbooks.user.finance.purchase-invoices')
        .controller('FinancePurchaseInvoicesController', FinancePurchaseInvoicesController);

        FinancePurchaseInvoicesController.$inject = [
            '$filter',
            '$stateParams',
            'purchaseInvoicesCollectionResponse',
            'suppliersCollectionResponse',
            '$state',
        ];

        function FinancePurchaseInvoicesController(
            $filter,
            $stateParams,
            purchaseInvoicesCollectionResponse,
            suppliersCollectionResponse,
            $state
        ) {
            var vm = this;

            vm.purchaseInvoicesCollectionResponse = purchaseInvoicesCollectionResponse;
            vm.purchaseInvoices = purchaseInvoicesCollectionResponse.invoices;
            vm.order = orderAction;
            vm.search = searchAction;

            var statusOptions = [
                {
                    title: $filter('translate')('INVOICE_STATUS_DRAFT'),
                    value: 'status_draft'
                },
                {
                    title: $filter('translate')('INVOICE_STATUS_IN_QUERY'),
                    value:'status_in_query'
                },
                {
                    title: $filter('translate')('INVOICE_STATUS_CANCELLED'),
                    value: 'status_cancelled'
                },
                {
                    title: $filter('translate')('INVOICE_STATUS_READY_FOR_PAYMENT'),
                    value: 'status_ready_for_payment'
                }
            ];

            vm.criteria = {
                id: {
                    type: 'id',
                    title: 'ID',
                    value: $stateParams.id
                },
                invoiceDateRange: {
                    type: 'date-range',
                    title: 'INVOICE_DATE_BETWEEN',
                    value: {
                        startDate: ($stateParams.invoiceDateRange !== null && typeof $stateParams.invoiceDateRange === 'string') ?
                            moment(new Date($stateParams.invoiceDateRange.split(',')[0])) :
                            null,
                        endDate: ($stateParams.invoiceDateRange !== null && typeof $stateParams.invoiceDateRange === 'string') ?
                            moment(new Date($stateParams.invoiceDateRange.split(',')[1])) :
                            null
                    },
                    clearValue: {
                        startDate: null,
                        endDate: null
                    }
                },
                supplier: {
                    type: 'jsonselectwidget',
                    title: 'SUPPLIER',
                    value: JSON.parse($stateParams.supplier),
                    options: {
                        response : suppliersCollectionResponse,
                        link : suppliersCollectionResponse ? suppliersCollectionResponse.getLink('self') : null,
                        itemValuePath: 'id',
                        itemTitlePath: 'name',
                        responseKeyPath: 'suppliers'
                    }
                },
                status:{
                    type: 'options',
                    title: 'STATUS',
                    multiple: true,
                    value: $stateParams.status,
                    options: statusOptions },
            }

            function orderAction(key) {
                $stateParams.purchaseInvoiceOrder = key;
                $state.go('.', angular.extend({}, $stateParams), { reload: $state.current });
            }

            function searchAction(params) {
                var override = {
                    purchaseInvoicePage: 1
                };

                $state.go('.', angular.extend({}, params, override), { reload: $state.current });
            }
        }
})();
